export default class Service {
  constructor (options) {
    this.kulapApi = options.kulapApi
  }
  async postCookieConsent (bannerText, status) {
    const data = {
      action: status,
      bannerText: bannerText,
      url: window.location.href,
      userAgent: navigator.userAgent,
      consents: {
        analytics: true,
        essential: true,
        marketing: true,
        personalization: true,
        uncategorized: true
      }
    }
    await this.kulapApi.postCookieConsent(data)

    return data
  }
}



// WEBPACK FOOTER //
// ./src/features/CookieConsent/service.js